import { EntityStatusDesc } from '../../../models/entity.model'
import { PackingListStatus } from '../models/packing-list.types'

export const PACKING_LIST_STATUSES: EntityStatusDesc<PackingListStatus>[] = [
  {
    code: 'PROCESSING',
    name: 'Processing',
  },
  {
    code: 'PACKED',
    name: 'PACKED',
  },
  {
    code: 'PRINTED',
    name: 'PRINTED',
  },
  {
    code: 'CANCELED',
    name: 'Canceled',
  },
]
